import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const StLouisCardinalsLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://www.mlb.com/cardinals/"
  >
    St. Louis Cardinals
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose your games.",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description: (
      <>
        Click Continue and connect your St. Louis Cardinals account using our
        secure{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          target="_blank"
          href="https://www.MLB.com/"
        >
          MLB.com
        </Link>{" "}
        login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <StLouisCardinalsLink /> account.
        Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "When will I receive my tickets?",
    description:
      "Once your reservation is accepted, the tickets will be available in the Ballpark app using the same email as your reservation.",
  },
  {
    title: "Is re-entry allowed?",
    description:
      "Fans can exit Gate 1 or Gate 4 and receive a hand stamp if they want to exit and re-enter the stadium. Guests with a hand stamp and valid event ticket can re-enter the stadium at any gate from the times gate open until 90 minutes after scheduled first pitch. All guests will have bags inspected and be screened via walk through metal detector upon re-entry.",
  },
  {
    title: "What is included in my suite?",
    description:
      "A buffet of ballpark fare is included in your suite, along with a full-service bar and bartender. If your reservation is accepted, a St. Louis Cardinals representative will be in contact with further information.",
  },
];

export function StLouisCardinalsCheckoutTerms() {
  return (
    <>
      In connection with your reservation, you will receive ticket-related
      commercial emails from{" "}
      <Link
        target="_blank"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://www.mlb.com/cardinals/"
      >
        https://www.mlb.com/cardinals/
      </Link>
      . You may unsubscribe at any time. By checking this box you agree to
      receive additional commercial emails from{" "}
      <Link
        target="_blank"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://www.mlb.com/cardinals/"
      >
        https://www.mlb.com/cardinals/
      </Link>{" "}
      and{" "}
      <Link
        target="_blank"
        href="http://MLB.com"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
      >
        MLB.com | The Official Site of Major League Baseball
      </Link>
      . The terms and conditions of your ticket and policies applicable to its
      use are available online at{" "}
      <Link
        target="_blank"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://www.mlb.com/cardinals/tickets/terms-and-conditions"
      >
        Cardinals Ticket Terms and Conditions | St. Louis Cardinals
      </Link>
      . By clicking the Purchase Tickets button, you agree to accept all Terms
      and Conditions. Your purchase is not complete until a St. Louis Cardinals
      representative connects with you to complete your purchase. Upon
      completing your purchase, you acknowledge and agree that your credit card
      will be charged. By clicking &apos;Purchase Tickets&apos;, you agree to
      the MLB Privacy Policy, Terms of Use and to receive your ticket(s) via an
      SMS text message to the mobile # associated with your St. Louis Cardinals
      account. Message and data rates may apply. Tickets will be made available
      in the MLB Ballpark mobile application only.{" "}
      <Link
        target="_blank"
        href="http://MLB.com"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
      >
        MLB.com | The Official Site of Major League Baseball
      </Link>{" "}
      and supported mobile device required.
    </>
  );
}

export function StLouisCardinalsAdditionalDetailsDisclaimerTC() {
  return (
    <>
      By entering my name, checking the box above and clicking Submit Request, I
      hereby (i) agree to the{" "}
      <Link
        target="_blank"
        href="https://www.mlb.com/cardinals/tickets/terms-and-conditions"
      >
        Terms of Use
      </Link>{" "}
      (ii) agree that my reservation will not be complete unless and until I
      receive a notice from the St. Louis Cardinals confirming whether or not my
      reservation has been accepted in accordance with our agreement.
    </>
  );
}
